<template>
    <div
        class="pb-4 md:pb-3 p-3 bg-white flex flex-col md:flex-row gap-6 rounded-lg"
    >
        <router-link
            class="block w-full h-[200px] md:w-[150px] md:h-[150px] hover:opacity-70 transition-opacity"
            :to="`/trips/${trip.uuid}`"
        >
            <div
                class="w-full h-[200px] md:w-[150px] md:h-[150px] rounded trip-card-image bg-center bg-cover"
                :style="
                    trip?.image?.path
                        ? { backgroundImage: `url(${tripImage})` }
                        : {}
                "
            ></div>
        </router-link>
        <div class="flex-1">
            <div class="w-full flex flex-col md:flex-row md:justify-between">
                <div class="flex-1 flex items-center justify-between gap-2">
                    <router-link
                        class="text-slate-800 hover:text-slate-400 transition-colors"
                        :to="`/trips/${trip.uuid}`"
                    >
                        <h2 class="text-xl font-medium flex items-center">
                            {{ trip.title }}
                            <span
                                v-if="trip.is_shared"
                                class="bg-orange-100 hover:bg-orange-50 text-orange p-[2px] px-2 rounded-lg text-xs font-medium leading-none ml-2 inline-flex h-6 items-center gap-1 flex-shrink-0"
                            >
                                <Icon
                                    icon="globe"
                                    v-bind:containerClass="'inline-block'"
                                    v-bind:svgClass="'inline m-1'"
                                    v-bind:width="16"
                                    v-bind:height="16"
                                    pathClass="text-orange"
                                />
                                Shared
                            </span>
                        </h2>
                    </router-link>
                    <div class="flex items-start justify-end gap-2 md:hidden">
                        <TripMoreActionsBtn
                            :trip="trip"
                            :hasBackground="false"
                        />
                    </div>
                </div>
                <div class="hidden md:flex items-center justify-end gap-2">
                    <button
                        class="h-11 flex px-4 py-2.5 bg-white hover:bg-slate-100 transition-colors rounded shadow border border-slate-200 items-center text-slate-800 text-sm font-medium gap-2"
                        @click="openRedemptionCreateModal"
                    >
                        <Icon icon="plus" :width="16" :height="16" />
                        <span>Add Redemption</span>
                    </button>
                    <router-link
                        class="h-11 flex px-4 py-2.5 bg-white hover:bg-slate-100 transition-colors rounded shadow border border-slate-200 items-center text-slate-800 text-sm font-medium gap-2"
                        :to="`/trips/${trip.uuid}`"
                    >
                        <span>View Trip</span>
                        <Icon
                            icon="chevron-right"
                            :width="16"
                            :height="16"
                            class="ml-auto"
                        />
                    </router-link>
                    <TripMoreActionsBtn :trip="trip" />
                </div>
            </div>
            <p class="text-slate-500 text-sm">
                <span v-if="trip?.city || trip?.state">
                    {{ trip.city ? trip.city : trip.state }},
                </span>
                {{ trip.country }}
            </p>
            <p class="text-slate-500 text-sm">
                {{ trip.start_date }} - {{ trip.end_date }}
            </p>
            <!--statistics redemption-->
            <div>
                <dl class="flex items-center gap-8 self-stretch pt-4">
                    <div class="grid grid-cols-2 sm:grid-cols-4 gap-4 w-full">
                        <!-- First block -->
                        <div class="flex flex-col items-start gap-1">
                            <dd
                                class="text-slate-800 text-[16px] font-medium leading-tight"
                            >
                                {{ trip.redemption_count }}
                            </dd>
                            <dt class="text-slate-500 text-[14px] font-medium">
                                Redemptions
                            </dt>
                        </div>

                        <!-- Second  block -->
                        <div class="flex flex-col items-start gap-1">
                            <dd
                                class="text-slate-800 text-[16px] font-medium leading-tight inline-flex items-center gap-1"
                            >
                                {{
                                    formatCurrency(
                                        parseFloat(trip.taxes_value) +
                                            parseFloat(trip.cash_value)
                                    )
                                }}
                                <div class="relative">
                                    <icon
                                        icon="chevron-down"
                                        :width="16"
                                        :height="16"
                                        class="text-slate-800 cursor-pointer p-1 rounded transition-colors"
                                        :class="{
                                            'bg-slate-100':
                                                isPopoverOpen.popover1,
                                        }"
                                        @click="togglePopover('popover1')"
                                        ref="popoverRef1"
                                    />
                                    <div
                                        v-if="isPopoverOpen.popover1"
                                        v-click-outside="
                                            () => closePopover('popover1')
                                        "
                                        ref="popover1"
                                        class="absolute z-10 md:mt-2 bg-white border border-slate-200 rounded-lg shadow-lg w-40 md:w-60 p-2 md:p-4 flex-col items-start gap-2 md:gap-3"
                                        :style="{
                                            position: strategy1,
                                            top: `${y1}px`,
                                            left: `${x1}px`,
                                        }"
                                    >
                                        <!--  right-[5px]  -->
                                        <template
                                            v-if="
                                                parseFloat(trip.taxes_value) +
                                                    parseFloat(
                                                        trip.cash_value
                                                    ) ===
                                                0
                                            "
                                        >
                                            <p
                                                class="text-slate-500 text-[14px] font-medium"
                                            >
                                                Details will display once you
                                                begin to add redemptions to this
                                                trip.
                                            </p>
                                        </template>
                                        <template v-else>
                                            <div class="flex justify-between">
                                                <h3
                                                    class="text-slate-500 text-[12px] md:text-[14px] font-medium"
                                                >
                                                    Cash cost
                                                </h3>
                                                <span
                                                    class="text-[12px] md:text-[14px]"
                                                >
                                                    {{
                                                        formatCurrency(
                                                            trip.cash_value
                                                        )
                                                    }}
                                                </span>
                                            </div>
                                            <div
                                                class="mt-4 flex justify-between"
                                            >
                                                <h3
                                                    class="text-slate-500 text-[12px] md:text-[14px] font-medium"
                                                >
                                                    Taxes & fees
                                                </h3>
                                                <span
                                                    class="text-[12px] md:text-[14px] text-right"
                                                >
                                                    {{
                                                        formatCurrency(
                                                            trip.taxes_value
                                                        )
                                                    }}
                                                </span>
                                            </div>
                                            <div
                                                class="mt-2 w-30 md:w-52 h-0.5 bg-[#E2E8F0]"
                                            ></div>
                                            <div
                                                class="mt-4 flex justify-between"
                                            >
                                                <h3
                                                    class="text-slate-500 text-[12px] md:text-[14px] font-medium"
                                                >
                                                    Total Value
                                                </h3>
                                                <span
                                                    class="text-[12px] md:text-[14px] text-right"
                                                >
                                                    {{
                                                        formatCurrency(
                                                            parseFloat(
                                                                trip.taxes_value
                                                            ) +
                                                                parseFloat(
                                                                    trip.cash_value
                                                                )
                                                        )
                                                    }}
                                                </span>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </dd>
                            <dt
                                class="text-slate-500 text-[14px] font-medium inline-flex items-center gap-1"
                            >
                                Total value
                                <div class="relative flex items-center">
                                    <icon
                                        icon="info"
                                        class="text-slate-500"
                                        @mouseover="showTooltip = true"
                                        @mouseleave="showTooltip = false"
                                    />
                                    <div
                                        v-show="showTooltip"
                                        class="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-75 py-1 px-2 text-sm text-white bg-[#213e44] rounded-lg shadow-lg md:whitespace-nowrap"
                                    >
                                        Total cash value of all redemptions on
                                        this trip.
                                    </div>
                                </div>
                            </dt>
                        </div>

                        <!-- Third block -->
                        <div class="flex flex-col items-start gap-1">
                            <dd
                                class="text-slate-800 text-[16px] font-medium leading-tight inline-flex items-center gap-1"
                            >
                                {{
                                    formatCurrency(
                                        parseFloat(trip.cash_spend_value) +
                                            parseFloat(
                                                trip.cash_spend_taxes_value
                                            )
                                    )
                                }}
                                <div class="relative">
                                    <icon
                                        icon="chevron-down"
                                        :width="16"
                                        :height="16"
                                        class="text-slate-800 cursor-pointer p-1 rounded transition-colors"
                                        :class="{
                                            'bg-slate-100':
                                                isPopoverOpen.popover2,
                                        }"
                                        @click="togglePopover('popover2')"
                                        ref="popoverRef2"
                                    />
                                    <div
                                        v-if="isPopoverOpen.popover2"
                                        v-click-outside="
                                            () => closePopover('popover2')
                                        "
                                        ref="popover2"
                                        class="absolute z-10 md:mt-2 bg-white border border-gray-200 rounded-lg shadow-lg w-40 md:w-60 p-2 md:p-4 flex-col items-start gap-2 md:gap-3"
                                        :style="{
                                            position: strategy2,
                                            top: `${y2}px`,
                                            left: `${x2}px`,
                                        }"
                                    >
                                        <template
                                            v-if="!trip.cash_spend_value && !trip.cash_spend_taxes_value"
                                        >
                                            <p
                                                class="text-slate-500 text-[14px] font-medium"
                                            >
                                                Details will display once you
                                                begin to add redemptions to this
                                                trip.
                                            </p>
                                        </template>
                                        <template v-else>
                                            <div class="flex justify-between">
                                                <h3
                                                    class="text-slate-500 text-[12px] md:text-[14px] font-medium"
                                                >
                                                    Cash cost
                                                </h3>
                                                <span
                                                    class="text-[12px] md:text-[14px]"
                                                >
                                                    {{
                                                        formatCurrency(
                                                            trip.cash_spend_value
                                                        )
                                                    }}
                                                </span>
                                            </div>
                                            <div
                                                class="mt-4 flex justify-between"
                                            >
                                                <h3
                                                    class="text-slate-500 text-[12px] md:text-[14px] font-medium"
                                                >
                                                    Taxes & fees
                                                </h3>
                                                <span
                                                    class="text-[12px] md:text-[14px] text-right"
                                                >
                                                    {{
                                                        formatCurrency(
                                                            trip.cash_spend_taxes_value
                                                        )
                                                    }}
                                                </span>
                                            </div>
                                            <div
                                                class="mt-2 w-30 md:w-52 h-0.5 bg-[#E2E8F0]"
                                            ></div>
                                            <div
                                                class="mt-4 flex justify-between"
                                            >
                                                <h3
                                                    class="text-slate-500 text-[12px] md:text-[14px] font-medium"
                                                >
                                                    Total
                                                </h3>
                                                <span
                                                    class="text-[12px] md:text-[14px] text-right"
                                                >
                                                    {{
                                                        formatCurrency(
                                                            parseFloat(
                                                                trip.cash_spend_value
                                                            ) +
                                                                parseFloat(
                                                                    trip.cash_spend_taxes_value
                                                                )
                                                        )
                                                    }}
                                                </span>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </dd>
                            <dt class="text-slate-500 text-[14px] font-medium">
                                Cash spent
                            </dt>
                        </div>

                        <!-- Fourth block -->
                        <div class="flex flex-col items-start gap-1">
                            <dd
                                class="text-slate-800 text-[16px] font-medium leading-tight inline-flex items-center gap-1"
                            >
                                {{ formatNumber(trip.payment_points) }}
                                <div class="relative">
                                    <icon
                                        icon="chevron-down"
                                        :width="16"
                                        :height="16"
                                        class="text-slate-800 cursor-pointer p-1 rounded transition-colors"
                                        :class="{
                                            'bg-slate-100':
                                                isPopoverOpen.popover3,
                                        }"
                                        @click="togglePopover('popover3')"
                                        ref="popoverRef3"
                                    />
                                    <div
                                        v-if="isPopoverOpen.popover3"
                                        v-click-outside="
                                            () => closePopover('popover3')
                                        "
                                        ref="popover3"
                                        class="absolute z-10 md:mt-2 bg-white border border-gray-200 rounded-lg shadow-lg w-40 md:w-60 p-2 md:p-4 flex-col items-start gap-2 md:gap-3"
                                        :style="{
                                            position: strategy3,
                                            top: `${y3}px`,
                                            left: `${x3}px`,
                                        }"
                                    >
                                        <template
                                            v-if="trip.payment_points === 0"
                                        >
                                            <p
                                                class="text-slate-500 text-[14px] font-medium"
                                            >
                                                Details will display once you
                                                begin to add redemptions to this
                                                trip.
                                            </p>
                                        </template>
                                        <template v-else>
                                            <div
                                                v-for="program in computedPointsPrograms"
                                                :key="
                                                    program.payment_program_id
                                                "
                                                class="flex justify-between items-center self-stretch mb-3"
                                            >
                                                <img
                                                    :src="`${cdnUrl}/${program.payment_program.program_image.path}/_small/${program.payment_program.program_image.file_name}`"
                                                    :title="
                                                        program.payment_program
                                                            .name
                                                    "
                                                    loading="eager"
                                                    class="mw-[120px] md:mw-[160px] h-[16px] md:h-[20px]"
                                                />
                                                <Icon
                                                    v-if="
                                                        !program.payment_program
                                                            .program_image
                                                    "
                                                    icon="credit-card"
                                                />

                                                <span
                                                    class="text-[12px] md:text-[14px]"
                                                >
                                                    {{
                                                        formatNumber(
                                                            program.payment_points
                                                        )
                                                    }}
                                                </span>
                                            </div>
                                            <div
                                                class="mt-2 w-40 md:w-52 h-0.5 bg-[#E2E8F0]"
                                            ></div>
                                            <div
                                                class="mt-4 flex justify-between"
                                            >
                                                <h3
                                                    class="text-slate-500 text-[12px] md:text-[14px] font-medium"
                                                >
                                                    Total
                                                </h3>
                                                <span
                                                    class="text-[12px] md:text-[14px] text-right"
                                                >
                                                    {{
                                                        formatNumber(
                                                            trip.payment_points
                                                        )
                                                    }}
                                                </span>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </dd>
                            <dt class="text-slate-500 text-[14px] font-medium">
                                Points spent
                            </dt>
                        </div>
                    </div>
                </dl>
            </div>
        </div>
    </div>
</template>

<script setup>
import TripMoreActionsBtn from '@/components/trips/trip-more-actions-btn.vue';
import Icon from '@/components/ui/icon/icon.vue';
import { ref, computed } from 'vue';
import currency from 'currency.js';
import { useTripsStore } from '@/store/trips';
import { storeToRefs } from 'pinia';
import { computePosition, flip, shift, offset, useFloating } from '@floating-ui/vue';

const tripsStore = useTripsStore();
const { showRedemptionCreateModal } = storeToRefs(tripsStore);

const props = defineProps({
    trip: {
        type: Object,
        required: true,
    },
});

const popoverRef1 = ref(null);
const popoverRef2 = ref(null);
const popoverRef3 = ref(null);
const popover1 = ref(null);
const popover2 = ref(null);
const popover3 = ref(null);

const cdnUrl = computed(() => {
    return window.cdnUrl;
});

const tripImage = computed(() => {
    return `${cdnUrl.value}/${props.trip?.image?.path}/${props.trip?.image?.file_name}`;
});

const computedPointsPrograms = computed(() => {
    return props.trip?.payment_points_detail?.reduce((arr, redemption) => {
        const programIndex = arr.findIndex(
            (item) => item.payment_program_id == redemption.payment_program_id
        );
        if (programIndex === -1) {
            arr.push({
                payment_program: redemption.payment_program,
                payment_points: redemption.payment_points,
                payment_program_id: redemption.payment_program_id,
            });
        } else {
            arr[programIndex].payment_points += redemption.payment_points;
        }

        return arr;
    }, []);
});

const formatCurrency = (amount) => {
    if (amount == null) {
        return '$0.00';
    }
    return currency(amount, { symbol: '$', precision: 2 }).format();
};

const formatNumber = (number) => {
    return Intl.NumberFormat('en-US').format(number);
};

const showTooltip = ref(false);
const isPopoverOpen = ref({
    popover1: false,
    popover2: false,
    popover3: false,
});

const {
    x: x1,
    y: y1,
    strategy: strategy1,
} = useFloating(popoverRef1, popover1, {
    placement: 'bottom-end',
    middleware: [offset(4), flip(), shift({ padding: 8 })],
});

const {
    x: x2,
    y: y2,
    strategy: strategy2,
} = useFloating(popoverRef2, popover2, {
    placement: 'bottom-end',
    middleware: [offset(4), flip(), shift({ padding: 2 })],
});

const {
    x: x3,
    y: y3,
    strategy: strategy3,
} = useFloating(popoverRef3, popover3, {
    placement: 'bottom-end',
    middleware: [offset(2), flip(), shift({ padding: 2 })],
});

const togglePopover = (popover) => {
    Object.keys(isPopoverOpen.value).forEach((key) => {
        isPopoverOpen.value[key] = false;
    });
    isPopoverOpen.value[popover] = !isPopoverOpen.value[popover];
};

const closePopover = (popover) => {
    isPopoverOpen.value[popover] = false;
};

const openRedemptionCreateModal = () => {
    tripsStore.getTrip(props.trip.uuid);
    tripsStore.setShowRedemptionCreateModal(true);
};

const closeRedemptionCreateModal = () => {
    tripsStore.closeModal();
};
</script>

<style scoped>
.trip-card-image {
    background: url('@@/images/default-placeholder.png') no-repeat center
        center/cover;
}
</style>
